module.exports = __webpack_public_path__ + "landing-page.219c47ffad491c378000.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/skye/Projects/Epicodus Projects/JavaScript/mock-mint/src/assets/img/landing-page.jpg
// module id = ../../../../../src/assets/img/landing-page.jpg
// module chunks = main